import app_config from '@/configs/share.conf.js'
import axios from 'axios'

let share = {
  share_info: function () {
    return {
      title : '南方周末',
      desc  : '南方周末移动端',
      link  : location.href.split("#")[0].split("?")[0],
      imgUrl: document.getElementById('share-icon') !== null ?
        document.getElementById('share-icon').src : '',
    }
  },
  share: function (share_text = app_config, options={}) {
    options = { url: app_config.wxApi(), onShared:function(){}, ...options }
    const { url } = options
    let that = this;
    //console.log(url)
    axios.get(url + encodeURIComponent(window.location.href), {
      transformResponse: function (response) {
        let returnData;
        try {
          returnData = (JSON.parse(response));
        } catch (err) {
          returnData = (response);
        }
        return returnData;
      },
    })
      .then(function (response) {
        let returnData = response.data.data;
        //console.log(returnData)
        if (wx) {
          wx.config({
            debug    : process.env.NODE_ENV !== 'production',
            appId    : returnData.appId,
            timestamp: returnData.timestamp,
            nonceStr : returnData.nonceStr,
            signature: returnData.signature,
            jsApiList: [
              'onMenuShareTimeline',
              'onMenuShareAppMessage',
              'onMenuShareQQ',
              'chooseWXPay'
            ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
          });
          wx.ready(function () {
              console.log(share_text)
            that.setShare(share_text, options.onShared)
          });
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  },
  setShare  : function (data, cb=function(){}) {
    wx.onMenuShareTimeline({
      title  : data.title, // 分享标题
      link   : data.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl : data.imgUrl, // 分享图标
      success: function () {
        cb('moments')
      },
      cancel : function () {
        // 用户取消分享后执行的回调函数
      }
    });
    wx.onMenuShareAppMessage({
      title  : data.title, // 分享标题
      desc   : data.desc, // 分享描述
      link   : data.link,  // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl : data.imgUrl, // 分享图标
      type   : '', // 分享类型,music、video或link，不填默认为link
      dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
      success: function () {
        cb('wechat')
      },
      cancel : function () {
        // 用户取消分享后执行的回调函数
      }
    });
    wx.onMenuShareQQ({
      title  : data.title, // 分享标题
      desc   : data.desc, // 分享描述
      link   : data.link,  // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl : data.imgUrl, // 分享图标
      success: function () {
        cb('qq')
      },
      cancel : function () {
        // 用户取消分享后执行的回调函数
      }
    });
  },
};
export default share
